import { get } from 'lodash';
import { connect } from 'react-redux';

import PractitionerDashboard from './component';

export default connect((state) => ({
  hasChimeMeeting: !!get(state, ['Meeting', 'chimeMeeting']),
}), (dispatch) => ({
  locationPractitionerLogin: () => dispatch({
    type: 'PRACTITIONER_LOGIN',
  }),
}))(PractitionerDashboard);
